var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditColorBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.75,
    height: 35,
    viewBox: "0 0 43.75 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-352 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 43.75,
    height: 35,
    transform: "translate(352 8)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "edit-2",
    "data-name": "edit",
    d: "M17.506,5,15.885,6.619a.422.422,0,0,1-.6,0l-3.9-3.9a.422.422,0,0,1,0-.6L13.006.5a1.691,1.691,0,0,1,2.387,0l2.113,2.113A1.685,1.685,0,0,1,17.506,5ZM9.993,3.511.76,12.744.015,17.015a.845.845,0,0,0,.977.977l4.272-.749L14.5,8.012a.422.422,0,0,0,0-.6l-3.9-3.9a.427.427,0,0,0-.6,0ZM4.364,11.953a.49.49,0,0,1,0-.7L9.778,5.842a.492.492,0,1,1,.7.7L5.06,11.953a.49.49,0,0,1-.7,0Z",
    transform: "translate(372.748 16.495)",
    fill: "#1c8dff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditColorBlue);
export default __webpack_public_path__ + "static/media/EditColorBlue.48bb9724e3c57bb1cad4998c9bfe8a51.svg";
export { ForwardRef as ReactComponent };